import { render } from "./Market.vue?vue&type=template&id=30e5e92c"
import script from "./Market.vue?vue&type=script&lang=js"
export * from "./Market.vue?vue&type=script&lang=js"
script.render = render

export default script